import React, { useState, useContext, useEffect } from "react";
import { post, get } from "../api/Api";
import Loader from "./Loader";
import { useNavigate } from "react-router-dom";
import * as constants from "../constants/constants";
import { AuthContext } from "../contexts/AuthContext";
import paisesAmerica from "../utils/paises_america";

function RegistrationForm() {
    const { setIsLoggedIn, setUserData } = useContext(AuthContext);
    const navigate = useNavigate();
    const [error, setError] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [departamentos, setDepartamentos] = useState([]);
    const [ciudades, setCiudades] = useState([]);
    const [paises, setPaises] = useState([]);
    const [empresas, setEmpresas] = useState([]);
    const [empresasError, setEmpresasError] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    const [formData, setFormData] = useState({
        nombres: "",
        apellidos: "",
        tipo_documento: "",
        documento: "",
        empresa_aliada_id: "",
        telefono: "",
        pais: "",
        departamento: "",
        ciudad: "",
        email: "",
        password: "",
        confirmacionPassword: "",
        terminos: false,
        contacto: false,
    });

    // Cargar la lista de países disponibles
    useEffect(() => {
        const paisesDisponibles = Object.keys(paisesAmerica);
        setPaises(paisesDisponibles);
    }, []);

    // Método para obtener las empresas aliadas
    const fetchEmpresasAliadas = async () => {
        try {
            setEmpresasError("");

            const response = await get("empresas-aliadas");

            if (response.data.success) {
                setEmpresas(response.data.data);
            } else {
                setEmpresasError(response.data.message);
            }
        } catch (error) {
            if (error) {
                setEmpresasError(error?.response?.data?.message || error.message);
            }
            console.error(error);
        }
    };

    const handleSubmitForm = (e) => {
        e.preventDefault();

        // Validación de correo electrónico
        if (!/\S+@\S+\.\S+/.test(formData.email)) {
            setError("El formato del correo electrónico no es válido.");
            return;
        }

        // Validar que las contraseñas coincidan
        if (formData.password !== formData.confirmacionPassword) {
            setError("Las contraseñas no coinciden. Por favor, intenta de nuevo.");
            return;
        }

        // Validar que el teléfono tenga exactamente 10 dígitos
        if (formData.telefono.length !== 10) {
            setError("El número de teléfono debe tener exactamente 10 dígitos.");
            return;
        }

        // Validar empresa aliada
        if (!formData.empresa_aliada_id) {
            setError("Por favor selecciona una empresa aliada.");
            return;
        }

        registarUsuario();
        setError(""); // Reinicia el mensaje de error
    };

    const registarUsuario = async () => {
        setIsLoading(true);

        try {
            const response = await post("registrar_usuario", formData);

            if (response.data.success) {
                setUserData(response.data.data);
                setIsLoggedIn(true);
                navigate(constants.CURSO);
            } else {
                setError(response.data.message);
            }
        } catch (error) {
            if (error) {
                setError(error?.response?.data?.message || error.message);
            }
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    };

    const handleChange = (e) => {
        setError("");
        const { name, value, type, checked } = e.target;

        const newFormData = {
            ...formData,
            [name]: type === "checkbox" ? checked : value,
        };

        if (name === "pais") {
            const deps = value ? Object.keys(paisesAmerica[value] || {}) : [];
            newFormData["departamento"] = "";
            newFormData["ciudad"] = "";
            setDepartamentos(deps);
            setCiudades([]);
        }

        if (name === "departamento") {
            const cids =
                value && newFormData.pais && paisesAmerica[newFormData.pais]
                    ? paisesAmerica[newFormData.pais][value] || []
                    : [];
            newFormData["ciudad"] = "";
            setCiudades(cids);
        }

        setFormData(newFormData);
    };

    // useEffect para ejecutar la función al montar el componente
    useEffect(() => {
        fetchEmpresasAliadas();
    }, []);

    return (
        <div className="auteco_formulario-registro">
            <form className="auteco_form" onSubmit={handleSubmitForm}>
                <div className="container-inputs-dobles">
                    <div className="auteco_input">
                        <label>Nombres</label>
                        <input
                            name="nombres"
                            type="text"
                            value={formData.nombres}
                            onChange={handleChange}
                            required
                        />
                    </div>

                    <div className="auteco_input">
                        <label>Apellidos</label>
                        <input
                            name="apellidos"
                            type="text"
                            value={formData.apellidos}
                            onChange={handleChange}
                            required
                        />
                    </div>
                </div>

                <div className="container-inputs-dobles">
                    <div className="auteco_select">
                        <label>Tipo de documento</label>
                        <select
                            name="tipo_documento"
                            value={formData.tipo_documento}
                            onChange={handleChange}
                            required
                        >
                            <option value="" disabled>
                                Selecciona una opción
                            </option>
                            <option value="Cédula de Ciudadanía">Cédula de Ciudadanía</option>
                            <option value="Cédula de Extranjería">
                                Cédula de Extranjería
                            </option>
                            <option value="Pasaporte">Pasaporte</option>
                            <option value="Otro">Otro</option>
                        </select>
                    </div>

                    <div className="auteco_input">
                        <label>Documento</label>
                        <input
                            name="documento"
                            type="text"
                            value={formData.documento}
                            onChange={handleChange}
                            required
                        />
                    </div>
                </div>

                <div className="container-inputs-dobles">
                    <div className="auteco_select">
                        <label>Aliados</label>
                        <select
                            name="empresa_aliada_id"
                            value={formData.empresa_aliada_id}
                            onChange={handleChange}
                            required
                        >
                            <option value="" disabled>
                                Selecciona un aliado
                            </option>
                            {empresas.map((opt) => (
                                <option key={opt.id} value={opt.id}>
                                    {opt.nombre}
                                </option>
                            ))}
                        </select>
                        {empresasError && (
                            <small className="auteco_error-message" style={{ marginTop: 6 }}>
                                {empresasError}
                            </small>
                        )}
                    </div>
                    <div className="auteco_select">
                        <label>Pais</label>
                        <select
                            name="pais"
                            value={formData.pais}
                            onChange={handleChange}
                            required
                        >
                            <option value="" disabled>
                                Selecciona una opción
                            </option>
                            {paises.map((pais) => (
                                <option key={pais} value={pais}>
                                    {pais}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>

                <div className="container-inputs-dobles">
                    <div className="auteco_select">
                        <label>Departamento/Estado</label>
                        <select
                            name="departamento"
                            value={formData.departamento}
                            onChange={handleChange}
                            required
                            disabled={!departamentos.length}
                        >
                            <option value="">Selecciona una opción</option>
                            {departamentos.map((dep) => (
                                <option key={dep} value={dep}>
                                    {dep}
                                </option>
                            ))}
                        </select>
                    </div>

                    <div className="auteco_select">
                        <label>Ciudad</label>
                        <select
                            name="ciudad"
                            value={formData.ciudad}
                            onChange={handleChange}
                            required
                            disabled={!ciudades.length}
                        >
                            <option value="" disabled>
                                Selecciona una opción
                            </option>
                            {ciudades.map((ciudad) => (
                                <option key={ciudad} value={ciudad}>
                                    {ciudad}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>

                <div className="container-inputs-dobles">
                    <div className="auteco_input">
                        <label>Teléfono</label>
                        <input
                            name="telefono"
                            type="numeric"
                            value={formData.telefono}
                            onChange={handleChange}
                            maxLength={10}
                            minLength={10}
                            onInput={(e) => {
                                e.target.value = e.target.value
                                    .replace(/[^0-9]/g, "")
                                    .slice(0, 10);
                            }}
                            required
                        />
                    </div>

                    <div className="auteco_input">
                        <label>Correo electrónico</label>
                        <input
                            name="email"
                            type="email"
                            value={formData.email}
                            onChange={handleChange}
                            required
                        />
                    </div>
                </div>

                <div className="container-inputs-dobles">
                    <div className="auteco_input" style={{ position: "relative" }}>
                        <label>Contraseña</label>
                        <input
                            name="password"
                            type={showPassword ? "text" : "password"}
                            value={formData.password}
                            onChange={handleChange}
                            required
                        />
                        <span
                            className="material-icons"
                            style={{
                                position: "absolute",
                                right: 10,
                                top: "50%",
                                cursor: "pointer",
                            }}
                            onClick={() => setShowPassword(!showPassword)}
                        >
                            {showPassword ? "visibility_off" : "visibility"}
                        </span>
                    </div>

                    <div className="auteco_input" style={{ position: "relative" }}>
                        <label>Confirmación de contraseña</label>
                        <input
                            name="confirmacionPassword"
                            type={showConfirmPassword ? "text" : "password"}
                            value={formData.confirmacionPassword}
                            onChange={handleChange}
                            required
                        />
                        <span
                            className="material-icons"
                            style={{
                                position: "absolute",
                                right: 10,
                                top: "50%",
                                cursor: "pointer",
                            }}
                            onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                        >
                            {showConfirmPassword ? "visibility_off" : "visibility"}
                        </span>
                    </div>
                </div>

                <div className="container-checkbox">
                    <div className="auteco_checkbox">
                        <input
                            type="checkbox"
                            name="terminos"
                            checked={formData.terminos}
                            onChange={handleChange}
                            required
                        />
                        <label>
                            <a
                                href="https://www.auteco.com.co/manual-de-politicas-y-procedimientos-de-datos"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Acepto todos los términos y condiciones
                            </a>
                        </label>
                    </div>

                    <div className="auteco_checkbox">
                        <input
                            type="checkbox"
                            name="contacto"
                            checked={formData.contacto}
                            onChange={handleChange}
                            required
                        />
                        <label>Acepto ser contactado por: sms, email y/o whatsapp</label>
                    </div>
                </div>

                {isLoading ? (
                    <Loader />
                ) : (
                    <div className="container-boton">
                        <button className="auteco_button primary" type="submit">
                            Registrarme
                        </button>
                    </div>
                )}

                {error && <div className="auteco_error-message">{error}</div>}
            </form>
        </div>
    );
}

export default RegistrationForm;
